<corp-header></corp-header>

<main
  role="main"
  class="simple-layout container"
>
  <router-outlet></router-outlet>
</main>
